/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Room_CountInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "room" |
* | "other" | "rooms" |
*
* @param {Room_CountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const room_count = /** @type {((inputs: Room_CountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_CountInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`room`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`rooms`);
		return /** @type {LocalizedString} */ ("room_count");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`pièce`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`pièces`);
		return /** @type {LocalizedString} */ ("room_count");
	}
});